import { Fragment, useEffect, useState } from "react";
import TopBar from "./TopBar";
import { Transition } from "@headlessui/react";
import SideBar from "./SideBar";

export default function DashLayout({ children }) {
  const [showNav, setShowNav] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  //   function handleResize() {
  //     if (innerWidth <= 640) {
  //       setShowNav(false);
  //       setIsMobile(true);
  //     } else {
  //       // setShowNav(true);
  //       setIsMobile(false);
  //     }
  //   }
  //   useEffect(() => {
  //     if (typeof window != undefined) {
  //       addEventListener("resize", handleResize);
  //     }

  //     return () => {
  //       removeEventListener("resize", handleResize);
  //     };
  //   }, []);

  return (
    <>
      <TopBar showNav={showNav} setShowNav={setShowNav} userName={"Admin"} />
      <Transition
        as={Fragment}
        show={showNav}
        enter="transform transition duration-[400ms]"
        enterFrom="-translate-x-full"
        enterTo="translate-x-0"
        leave="transform duration-[400ms] transition ease-in-out"
        leaveFrom="translate-x-0"
        leaveTo="-translate-x-full"
      >
        <SideBar showNav={showNav} role={"ADMIN"} userName={"Admin"} />
      </Transition>
      <main
        className={`pt-16 transition-all duration-[400ms] bg-slate-100 h-screen max-h-screen ${
          showNav && !isMobile ? "pl-56" : ""
        }`}
      >
        <div className="px-4 md:px-16 mt-16 ">{children}</div>
      </main>
    </>
  );
}
